import { Input, OnDestroy, OnInit, Directive } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Directive()
export abstract class SelectEntitiesDialogComponent<T> implements OnInit, OnDestroy {
    @Input()
    entitie$: Observable<T[]>;

    searchInput = new FormControl();
    list: T[] = [];

    protected _unsubscribeAll: Subject<any>;

    constructor(protected _store: Store, public dialogRef: MatDialogRef<SelectEntitiesDialogComponent<T>>, private SearchEntities, private FetchEntities) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.searchInput.valueChanges.pipe(takeUntil(this._unsubscribeAll), debounceTime(300), distinctUntilChanged()).subscribe((searchText) => {
            this._store.dispatch(new this.SearchEntities(searchText));
        });
    }

    /**
     * On init
     */
    ngOnInit(): void {
        if (this.FetchEntities) {
            this._store.dispatch(new this.FetchEntities());
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(undefined);
        this._unsubscribeAll.complete();
        this._store.dispatch(new this.SearchEntities(null));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Add entity to list
     *
     * @param entity
     */

    addToList(entity: T): void {
        this.list = [...this.list, entity];

        setTimeout(() => {
            this.searchInput.setValue('');
        });
    }

    /**
     * Remove entity from list
     *
     * @param index
     */

    removeFromList(index: number): void {
        if (index > -1) {
            this.list = [...this.list.filter((item, idx) => idx !== index)];
        }
    }

    /**
     * Save selected entities
     */

    saveSelected(): void {
        this.dialogRef.close({ data: this.list });
    }
}
